import { createAction } from 'redux-actions-helpers';

export const showModal = createAction('@@modal/SHOW', (src) => ({
    src
}));
export const hideModal = createAction('@@modal/HIDE');



// WEBPACK FOOTER //
// ./src/blocks/modal/actions.js